"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TICK_LABEL_PADDING = exports.ANGULAR_TICK_INTERVAL = exports.TICK_INTERVAL = exports.HOVER_SLOP = exports.MAX_TICK_COUNT = exports.MIN_TICK_COUNT = exports.TICK_WIDTH = exports.BAR_SIZE = exports.BULLET_SIZE = exports.TARGET_STROKE_WIDTH = exports.TARGET_SIZE = void 0;
exports.TARGET_SIZE = 40;
exports.TARGET_STROKE_WIDTH = 3;
exports.BULLET_SIZE = 32;
exports.BAR_SIZE = 12;
exports.TICK_WIDTH = 1;
exports.MIN_TICK_COUNT = 3;
exports.MAX_TICK_COUNT = 8;
exports.HOVER_SLOP = 20;
exports.TICK_INTERVAL = 100;
exports.ANGULAR_TICK_INTERVAL = 120;
exports.TICK_LABEL_PADDING = 3;
//# sourceMappingURL=constants.js.map